<div>
    <div class="cart-header my-session-header-background">
        <h3>
            <i class="fa fa-lg"  role="presentation" [ngClass]="[mysessionConfig.drawer_button.icon, 'cart-icon']"></i>
            <span [ngClass]="'my-session-header-label'">
                {{ mysessionConfig.header.label }}
            </span>
        </h3>
    </div>
    <div class="cart-body">
        <div
            class="form-link pull-right"
            *ngIf="
                mysessionConfig.formId != null &&
                mysessionConfig.formDTO != null &&
                mysessionConfig.formDTO.pkFormId != null
            "
        >
            <a
                href="/profile/form/index.cfm?PKformID={{
                    mysessionConfig.formDTO.pkFormId
                }}&varPage=verify&pkProfileId={{ this.sharedService.loggedInAttendee.profile.pkProfileId }}"
                target="_blank"
                id="continue-with-registration-label"
                >{{ 'cart_section.continue_with_registration' | translate }}</a
            >
        </div>
        <div class="clearfix"></div>
        <div class="cart-container">
            <div class="cart-tabs">
                <div title="Selected"
                    *ngIf="buttonConfig.enableAddToCartButton"
                    class="cart-tab pull-left"
                    (cclClick)="toggleTab('registered')"
                    [ngClass]="{
                        'my-session-tab-cart-inactive': selectedTab != 'registered',
                        'my-session-tab-cart-active': selectedTab == 'registered',
                        active: selectedTab == 'registered'
                    }"
                    id="selected-label"
                >
                {{ 'cart_section.selected' | translate }}
                    <span *ngIf="sharedService.cartData != undefined && sharedService.cartData != null; else zero"
                        >{{ sharedService.cartData.size > 0 ? "(" + sharedService.cartData.size + ")" :
                        "&nbsp;&nbsp;&nbsp;&nbsp;" }}</span
                    ><ng-template #zero>&nbsp;&nbsp;&nbsp;&nbsp;</ng-template>
                </div>
                <div title="Favorites"
                    class="cart-tab  pull-left"
                    (cclClick)="toggleTab('favorites')"
                    [ngClass]="{
                        'my-session-tab-cart-inactive': selectedTab != 'favorites',
                        'my-session-tab-cart-active': selectedTab == 'favorites',
                        active: selectedTab == 'favorites'
                    }"
                    id="favourite-label"
                >
                {{ 'cart_section.favourites' | translate }}
                    <span *ngIf="sharedService.favData != undefined && sharedService.favData != null; else fzero"
                        >{{ sharedService.favData.size > 0 ? "(" + sharedService.favData.size + ")" :
                        "&nbsp;&nbsp;&nbsp;&nbsp;" }}</span
                    ><ng-template #fzero>&nbsp;&nbsp;&nbsp;&nbsp;</ng-template>
                </div>
                <div title="Hidden"
                    *ngIf="false"
                    class="cart-tab  pull-left"
                    (cclClick)="toggleTab('excluded')"
                    [ngClass]="{ active: selectedTab == 'excluded' }"
                    [ngStyle]="{
                        color:
                            selectedTab == 'excluded'
                                ? mysessionConfig.tabConfig.activeLabelColor
                                : mysessionConfig.tabConfig.inactiveLabelColor,
                        margin: '5px',
                        'border-bottom-color':
                            selectedTab == 'excluded'
                                ? mysessionConfig.tabConfig.activeBorderColor
                                : mysessionConfig.tabConfig.inactiveBorderColor,
                        'border-bottom-style': mysessionConfig.tabConfig.borderStyle
                    }"
                    id="hidden-label"
                >
                    Hidden
                    <span *ngIf="sharedService.excData != undefined && sharedService.excData != null; else fzero"
                        >({{ sharedService.excData.size }})</span
                    ><ng-template #fzero>(0)</ng-template>
                </div>
            </div>
            <div class="clearfix"></div>
            <div
                class="cart-tab-content"
                *ngIf="
                    selectedTab == 'registered' &&
                    (sharedService.cartData != undefined && sharedService.cartData != null)
                "
            >
                <div class="general-list-loader">
                    <img alt="Loading..." *ngIf="isLoading" src="assets/images/loading.gif" />
                    <span *ngIf="!isLoading && sharedService.cartData.size == 0" id="no-session-cart-label"
                        >{{ 'cart_section.no_session_in_cart' | translate }}</span
                    >
                </div>
                <div #listViewContainer></div>
                <div *ngIf="section != 'reg' && render">
                    <div *ngIf="renderView(selectedTab)"></div>
                </div>
            </div>
            <div
                class="cart-tab-content"
                *ngIf="
                    selectedTab == 'favorites' && (sharedService.favData != undefined && sharedService.favData != null)
                "
            >
                <div class="general-list-loader">
                    <img alt="Loading..." *ngIf="isLoading" src="assets/images/loading.gif" />
                    <span *ngIf="!isLoading && sharedService.favData.size == 0" id="no-fav-session-label"
                        >{{ 'cart_section.no_fav_session' | translate }}</span
                    >
                </div>
                <div #listViewContainer></div>
                <div *ngIf="section != 'fav' && render">
                    <div *ngIf="renderView(selectedTab)"></div>
                </div>
            </div>
            <div
                class="cart-tab-content"
                *ngIf="
                    selectedTab == 'excluded' && (sharedService.excData != undefined && sharedService.excData != null)
                "
            >
                <div #listViewContainer></div>
                <div *ngIf="section != 'exc' && render">
                    <div *ngIf="renderView(selectedTab)"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="cart-footer">
        <button
            class="c-btn c-btn--primary my-session-button-primary"
            (click)="processCart()"
            *ngIf="
                selectedTab == 'registered' &&
                (sharedService.cartData != undefined && sharedService.cartData != null) &&
                sharedService.cartData.size > 0
            "
            id="add-schedule-label"
        >
        {{ 'cart_section.add_to_schedule' | translate }}
        </button>
        <button
            class="c-btn c-btn--secondary my-session-button-secondary"
            (click)="clearCart()"
            *ngIf="
                selectedTab == 'registered' &&
                (sharedService.cartData != undefined && sharedService.cartData != null) &&
                sharedService.cartData.size > 0
            "
            id="remove-all-label"
        >
        {{ 'cart_section.remove_all' | translate }}
        </button>
        <button
            class="c-btn c-btn--primary my-session-button-primary"
            (click)="addAllToCart()"
            *ngIf="
                selectedTab == 'favorites' &&
                (sharedService.favData != undefined && sharedService.favData != null) &&
                sharedService.favData.size > 0 &&
                buttonConfig.enableAddToCartButton
            "
            id="add-to-cart-label"
        >
        {{ 'cart_section.add_all_to_cart' | translate }}
        </button>
        <button
            class="c-btn c-btn--secondary my-session-button-secondary"
            (click)="removeAll(false)"
            *ngIf="
                selectedTab == 'favorites' &&
                (sharedService.favData != undefined && sharedService.favData != null) &&
                sharedService.favData.size > 0
            "
            id="remove-all-label"
        >
            {{ 'cart_section.remove_all' | translate }}
        </button>
        <button
            class="c-btn c-btn--secondary my-session-button-secondary"
            (click)="removeAll(true)"
            *ngIf="
                selectedTab == 'excluded' &&
                (sharedService.excData != undefined && sharedService.excData != null) &&
                sharedService.excData.size > 0
            "
            id="remove-all-label"
        >
            {{ 'cart_section.remove_all' | translate }}
        </button>
    </div>
</div>
